import { useCallback, useRef, useMemo, useContext, useEffect } from 'react';
import { WebViewManagerContext } from 'app/home/general-components/WebViewManagerContext';

export default function useAddDeviceController(sendEvent, negotiatedProtocol) {
    const wm = useContext(WebViewManagerContext);

    useEffect(() => {
        if (negotiatedProtocol.isSolo && (wm.webViewState.supportUDP && wm.webViewState.supportESPTouchV1)) {
            wm.notify("listen-udp", 3361);
        }
    }, [negotiatedProtocol.isSolo, wm]);

    const addDeviceCallbacks = useRef({});
    const registerNotification = useCallback((callbackId, callback) => {
        addDeviceCallbacks.current[callbackId] = callback;
    }, []);
    const unregisterNotification = useCallback((callbackId) => {
        if (callbackId in addDeviceCallbacks.current)
            delete addDeviceCallbacks.current[callbackId];
    }, []);

    const search = useCallback((deviceTypes, ssid, password) => {
        let json = {
            "sub_event": "start_search",
            "device_types": deviceTypes
        }
        if (ssid !== undefined)
            json["ssid"] = ssid;
        if (password !== undefined)
            json["password"] = password;

        sendEvent('add_device', json);
    }, [sendEvent]);

    const join = useCallback((deviceId, roomIdToAddTo, config) => {
        if (roomIdToAddTo !== undefined) {
            sendEvent('add_device', {
                "sub_event": "join_device",
                "device_id": deviceId,
                "room_id": roomIdToAddTo,
                "config": config
            });
        } else {
            sendEvent('add_device', {
                "sub_event": "join_device",
                "device_id": deviceId,
                "config": config
            });
        }
    }, [sendEvent]);

    const indicate = useCallback((deviceId) => {
        sendEvent('indicate_device', {
            "device_id": deviceId
        });
    }, [sendEvent]);

    const onAddDevice = useCallback((message) => {
        switch (message.msg.sub_event) {
            case "device_found_notification":
            case "error":
            case "search_has_started":
            case "search_has_ended":
            case "device_joined_notification":
                for (const id in addDeviceCallbacks.current) {
                    // if (addDeviceCallbacks.current.hasOwnProperty(id)) {
                    if (Object.prototype.hasOwnProperty.call(addDeviceCallbacks.current, id)) {
                        const callback = addDeviceCallbacks.current[id];
                        callback(message.msg);
                    }
                }
                break;
            default:
                break;
        }
    }, []);

    const addDeviceController = useMemo(() => {
        return {
            registerNotification,
            unregisterNotification,

            search,
            indicate,
            join,
        }
    }, [registerNotification, unregisterNotification, search, join, indicate]);
    return [onAddDevice, addDeviceController];
}
